/**
 * Ferme aux lecteurs les pages de creation et de modification.
 *
 * Voir `admin.ts` pour la dependance a `auth.global.ts`.
 */
export default defineNuxtRouteMiddleware(() => {
  const { canWrite } = useAuthorization()

  if (!canWrite.value) {
    throw createError({
      statusCode: 403,
      message: 'Accès en lecture seule',
    })
  }
})
